export default {"src":"/_next/static/media/WhoWeAre_009A.ca87a67d.JPG","height":698,"width":1920};